<div class="dialog-container">
  <div class="dialog-header">
    <p class="title">Scenario Information</p>
    <button type="button" class="btn-close shadow-none" (click)="onClose()" title="Close"></button>
  </div>
  <div class="dialog-content">
    <form [formGroup]="scenarioForm" class="create-form">
      <div class="form-full-width">
        <label>Scenario Name</label>
        <span class="p-input-icon-right">
          <i class="fa fa-pencil icon" matSuffix (click)="onEnableEdit()"></i>
          <input pInputText formControlName="scenario_name" [readonly]="!enableEdit" />
        </span>
      </div>
      <div class="form-full-width">
        <label htmlFor="created_by">Created By</label>
        <input pInputText id="created_by" formControlName="created_by" readonly />
      </div>
      <div class="form-full-width">
        <label htmlFor="created_at">Date Of Creation</label>
        <input pInputText id="created_at" formControlName="created_at" readonly />
      </div>
      <div class="form-full-width">
        <label htmlFor="iteration_last_updated">Last Updated On</label>
        <input pInputText id="iteration_last_updated" formControlName="iteration_last_updated" readonly />
      </div>
      <div class="form-full-width">
        <label htmlFor="scenario_description">Scenario Description</label>
        <span class="p-input-icon-right">
          <i class="fa fa-pencil icon" matSuffix (click)="onEnableEdit()"></i>
          <textarea pInputTextarea id="scenario_description" formControlName="scenario_description" [readonly]="!enableEdit"></textarea>
        </span>
      </div>
    </form>
  </div>
  <div class="dialog-footer">
    <button class="mdlz-btn" (click)="onUpdateScenario()" mat-button *ngIf="enableEdit">Update Scenario</button>
    <button class="mdlz-btn" (click)="onGoBack()" mat-button>Back</button>
  </div>
</div>
